import {ApolloError} from "@apollo/client";

/** Server-Code der Mitarbeiter-Sperre für Bezahlmethoden (#1008, ADR 0013). */
export const PAYMENT_METHOD_NOT_RELEASED_CODE = "PAYMENT_METHOD_NOT_RELEASED";

/** Überschrift für die Anzeige der Sperre. */
export const PAYMENT_METHOD_NOT_RELEASED_TITLE = "Bezahlmethode nicht freigegeben";

/**
 * Meldung der Sperre aus dem Server-Fehler, sonst undefined. Der Server formuliert sie bereits
 * für Mitarbeiter (nennt die gesperrte Art und den Ausweg), deshalb wird sie direkt angezeigt.
 */
export const paymentMethodNotReleasedMessage = (error: unknown): string | undefined => {
    if (!(error instanceof ApolloError)) {
        return undefined;
    }

    const graphQLError = (error.graphQLErrors ?? []).find((candidate) => candidate.extensions?.code === PAYMENT_METHOD_NOT_RELEASED_CODE);

    return graphQLError ? graphQLError.message : undefined;
};
